import { StyleSheet } from 'aphrodite';
import { AppTheme } from '../styles/AppTheme';

// Styles to be reused between more than one component
export const CommonStyles = StyleSheet.create({
  textfulPageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    margin: 20,
    maxWidth: 900,
    paddingBottom: 100
  },
  textfulPageSubtitle: {
    fontSize: 16
  },
  textfulPagePara: {
    fontSize: 12
  },
  outerContainer: {
    padding: 10,
    paddingTop: 30,
    paddingBottom: 30,
    width: '95%',
    //display: 'flex',
  },
  marginLeft: {
    marginLeft: 10
  },
  fillSpace: {
    flex:1
  },

  navLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: AppTheme.secondaryBg,
    marginRight: 10,
    padding: 5
  },
  navIcon: {
    marginRight: 5,
    fontSize: 35
  },
  navTitle: {
    fontWeight: 600,
    fontSize: 18,
    margin: 0
  },
});


// WEBPACK FOOTER //
// ./src/styles/Styles.js